import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTable } from '@celebration/design-system/dist/lib/table';

export default createComponent({
    react: React,
    elementClass: ClbTable,
    tagName: ClbTable.tagName,
    events: ClbTable.events,
});
